import BranchBox from '@theme/components/content/BranchBox'

export default {
  props: {
    branches: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: {
    BranchBox,
  },
}
